import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import './directive/index'
import './router/RouterChangeHandle' // 路由跳转事件
import './components/ContextMenu/index'
import './components/MessageCard/index'
import store from '@/store'

import '@/styles/index.css'

import MyLoading from '@/components/MyLoading/index'

import VePie from 'v-charts/lib/pie'
import VeLine from 'v-charts/lib/line'

import $selectMovie from '@/components/SelectMovie/index.js'

Vue.prototype.$selectMovie = $selectMovie

Vue.component(VePie.name, VePie)
Vue.component(VeLine.name, VeLine)

Vue.prototype.$myLoading = MyLoading

Vue.config.productionTip = false

document.title = process.env.TITLE

if (process.env.VERSION === 'host') {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = '/static/favicon1.ico'
  document.getElementsByTagName('head')[0].appendChild(link)
}

// 配置element-ui大小风格
Vue.use(ElementUI, { size: 'medium' })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js